{
	"title": "Garantire l’accountability installando una carbon bank",
	"description": "Heidelberg Materials ha adottato misure approfondite per garantire la credibilità delle riduzioni di carbonio generate dal nostro cementificio con CCS. Per prevenire qualsiasi possibilità di doppia contabilizzazione, abbiamo implementato una carbon bank virtuale sicura su un registro distribuito pubblico.",
	"traceabilityTitle": "Tracciabilità delle riduzioni di carbonio"
}
